import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacyCs10() {
  return (
    <div>
      <Heading
        type={`h3`}
        title={
          <>
            {`X.`}
            <br />
            {`Doručování`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`Oznámení týkající se vztahů poskytovatele a uživatele, zejména týkající odstoupení od smlouvy, může být doručena poštou formou doporučeného dopisu, emailem či prostřednictvím uživatelského účtu. Oznámení se doručují na příslušnou kontaktní adresu druhé strany a považují se za doručené a účinné okamžikem jejich dodání prostřednictvím pošty, s výjimkou oznámení o odstoupení od smlouvy učiněného uživatelem, kdy je odstoupení účinné, pokud je oznámení uživateli ve lhůtě pro odstoupení odesláno. `}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={2} className={sList}>
            <li>{`Za doručené se považuje i oznámení, jehož převzetí bylo adresátem odmítnuto, které nebylo vyzvednuto v úložní době, nebo které se vrátilo jako nedoručitelné. `}</li>
            <li>{`Smluvní strany můžou běžnou korespondenci vzájemně doručovat prostřednictvím elektronické pošty, a to na adresu elektronické pošty uvedenou v uživatelském účtu uživatele či uvedenou uživatelem v objednávce, resp. na adresu uvedenou na webové stránce poskytovatele. `}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacyCs10;
